import React from 'react';

export const JsxUtilService = {
    multiplyJsxElement(jsxElement, times) {
        return jsxElement ? (new Array(times))
            .fill(undefined)
            .map((content, index) => (
                <React.Fragment key={index}>{jsxElement}</React.Fragment>
            )) : null;
    }
};
